import React from "react";
import { useId } from "../../hooks/use-id";
import { FormMessage } from "../../components/shared/form-message";

/**
 * Campo de entrada para el documento de identificación del usuario.
 *
 * Renderiza un campo numérico para capturar el número de identificación,
 * registra el campo en React Hook Form y valida que sea obligatorio.
 * Cuando la validación falla, muestra el mensaje de error correspondiente.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.formController - Instancia de React Hook Form utilizada para registrar y validar el campo.
 * @param {Object} props.texts - Objeto con los textos traducidos utilizados en la interfaz.
 *
 * @returns {JSX.Element} InstIdField
 */
export const InstIdField = ({ formController, texts }) => {
    const { institucional } = texts;
    const { form } = institucional;

    const documento = useId('documento');
    
    // Identificador utilizado por React Hook Form para registrar el campo.
    const fieldDocumento = 'documento';

    const {
        register,
        formState: { errors } } = formController

    return (
        <>
            <label
                htmlFor={documento}
                className="secondary-item"
            >
                <strong>
                    {form?.cedula?.label_doc || 'Documento de identificación*:'}
                </strong>
            </label>
            <input
                type="number"
                className="form-control focusable-secondary"
                id={documento}
                placeholder={
                    form?.cedula?.placeholder_doc || "Escribe tu número de identificación"
                }
                {...register(
                    fieldDocumento,
                    {
                        required: {
                            value: true,
                            message:  form?.cedula?.alert_doc || "Debes escribir tu número de identificación"
                        }
                    }
                )}
            />

            <FormMessage
                message={errors[fieldDocumento]?.message}
                type={"error"}
            />
        </>
    )
}